export const SECTION_EYEBROW_CLASS =
  "font-urbanist text-sm font-semibold uppercase tracking-[0.18em] text-[#270400]/65 sm:text-base";

export const SECTION_TITLE_CLASS =
  "font-urbanist mt-3 text-4xl font-semibold tracking-tight text-pretty text-[#270400] sm:text-5xl";

export const SECTION_BODY_CLASS =
  "font-manrope text-lg leading-8 text-[#270400]/78 sm:text-xl";

export const SECTION_BODY_SECONDARY_CLASS =
  "font-manrope text-lg leading-8 text-[#270400]/78";
